import i18n from "@/i18n";

import type {
  CheckoutTemplate,
  ServicePreviewContent,
} from "@/models/checkout";

const t = i18n.global.t;

export const CHECKOUT_TEMPLATE_SCHEMA_VERSION = "2.2.0";

export const CHECKOUT_NEW_ID = "new";

export const NEW_TEMPLATE: CheckoutTemplate = {
  id: "",
  name: "",
  description: "",
  content: {
    title: "",
    subtitle: "",
    steps: [],
    should_mask_piis: false,
    finalize: {
      title: "",
      description: "",
    },
  },
};

export const SERVICE_PREVIEW_CONTENT: Record<string, ServicePreviewContent> = {
  chart: {
    title: "CHECKOUT.SERVICE_PREVIEW.CHART.TITLE",
    description: "CHECKOUT.SERVICE_PREVIEW.CHART.DESCRIPTION",
    buttonText: "CHECKOUT.SERVICE_PREVIEW.CHART.BUTTON",
  },
  vouched_verification: {
    title: "CHECKOUT.SERVICE_PREVIEW.VOUCHED_VERIFICATION.TITLE",
    description: "CHECKOUT.SERVICE_PREVIEW.VOUCHED_VERIFICATION.DESCRIPTION",
    buttonText: "CHECKOUT.SERVICE_PREVIEW.VOUCHED_VERIFICATION.BUTTON",
  },
};

export const PREVIEW_MOCK_OFFER = {
  offerSummary: [
    {
      name: t("CHECKOUT.MOCK_OFFER.OFFER_AMOUNT"),
      value: t("CHECKOUT.MOCK_OFFER.OFFER_AMOUNT_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.TERM_TIMEFRAME"),
      value: t("CHECKOUT.MOCK_OFFER.TERM_TIMEFRAME_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.PAYMENT_FREQUENCY"),
      value: t("CHECKOUT.MOCK_OFFER.PAYMENT_FREQUENCY_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.TERM_OF_LOAN"),
      value: t("CHECKOUT.MOCK_OFFER.TERM_OF_LOAN_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.PAYMENT_AMOUNT"),
      value: t("CHECKOUT.MOCK_OFFER.PAYMENT_AMOUNT_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.INTEREST_RATE"),
      value: t("CHECKOUT.MOCK_OFFER.INTEREST_RATE_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.NUMBER_OF_PAYMENTS"),
      value: t("CHECKOUT.MOCK_OFFER.NUMBER_OF_PAYMENTS_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.OFFER_EXPIRATION_DATE"),
      value: t("CHECKOUT.MOCK_OFFER.OFFER_EXPIRATION_DATE_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.DOWN_PAYMENT"),
      value: t("CHECKOUT.MOCK_OFFER.DOWN_PAYMENT_VALUE"),
    },
    {
      name: t("CHECKOUT.MOCK_OFFER.CLOSING_COST"),
      value: t("CHECKOUT.MOCK_OFFER.CLOSING_COST_VALUE"),
    },
  ],
  requiredDocuments: [
    t("CHECKOUT.MOCK_OFFER.REQUIRED_DOCUMENTS.DRIVERS_LICENCE"),
    t("CHECKOUT.MOCK_OFFER.REQUIRED_DOCUMENTS.ID_CARD"),
    t("CHECKOUT.MOCK_OFFER.REQUIRED_DOCUMENTS.VOIDED_CHECK"),
  ],
};
